// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "credit_transactions".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { creditChannelValues, creditTransactionTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "credit_transactions" table (1:1 with a DB row, on the wire). */
export const creditTransactionsAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    type: z.enum(creditTransactionTypeValues),
    amount: z.number(),
    balanceAfter: z.number(),
    channel: z.enum(creditChannelValues).nullable(),
    referenceId: z.string().nullable(),
    referenceType: z.string().nullable(),
    description: z.string().nullable(),
    metadata: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=creditTransactions.js.map